import { styled } from "@mui/material";
import { runeTheme } from "../common/RuneTheme";

export const NoResourceMessage = styled("div")({
  fontSize: "16px",
  background: runeTheme.palette.background.light,
  padding: "30px"
});
